import React, { useEffect } from "react"
import dynamic from "next/dynamic"
import { useDispatch, useSelector } from "react-redux"
import { TextInfoBlock1 } from "@/components/Remedy/components/TextInfoBlock1"
import styles from "@/components/Remedy/Remedy.module.scss"
import { Box } from "@kohler-dsm-library/kohler-core"
import { FAQSection } from "@/components/Remedy/components/FAQSection"
import {
  selectGenericState,
  toggleSiteWideWarning,
} from "@/store/features/genericSlice"

const HeroBlockSection = dynamic(() =>
  import(
    "@/components/Remedy/components/HeroBlockSection/HeroBlockSection"
  ).then(mod => mod.HeroBlockSection)
)
const ScrollyBlock = dynamic(() =>
  import("@/components/Remedy/components/ScrollyBlock/ScrollyBlock").then(
    mod => mod.ScrollyBlock
  )
)
const ErgonomicsSection = dynamic(() =>
  import(
    "@/components/Remedy/components/ErgonomicsSection/ErgonomicsSection"
  ).then(mod => mod.ErgonomicsSection)
)
const TextInfoBlock2 = dynamic(() =>
  import("@/components/Remedy/components/TextInfoBlock2/TextInfoBlock2").then(
    mod => mod.TextInfoBlock2
  )
)
const TimerVideoBlock = dynamic(() =>
  import("@/components/Remedy/components/TimerVideoBlock/TimerVideoBlock").then(
    mod => mod.TimerVideoBlock
  )
)
const BathLogoVideo = dynamic(() =>
  import("@/components/Remedy/components/BathLogoVideo/BathLogoVideo").then(
    mod => mod.BathLogoVideo
  )
)
const TechnicalSpecificationsSection = dynamic(() =>
  import(
    "@/components/Remedy/components/TechnicalSpecificationsSection/TechnicalSpecificationsSection"
  ).then(mod => mod.TechnicalSpecificationsSection)
)

const Remedy = ({ ctaTitle = "", ctaUrl = "" }) => {
  const dispatch = useDispatch()
  const { enableSiteWideWarning } = useSelector(selectGenericState)

  useEffect(() => {
    if (enableSiteWideWarning) dispatch(toggleSiteWideWarning())

    if (!history || !window) return

    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual"
    }

    window.document.body.scrollTop = 0
    window.document.documentElement.scrollTop = 0

    return () => {
      dispatch(toggleSiteWideWarning())
    }
  }, [])

  return (
    <Box id="remedy-page" mod="charcoal" className={styles["remedy-pxp"]}>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          
          .gbh-header-logo-menu.header-mega-menu-container {
            position: absolute !important;
            top: 43px;
          }

          .header-mega-menu-container:not(.gbh-header-logo-menu) {
            background-color: #212121 !important;
          }

          @media (width < 512px) {
              .gbh-header-logo-menu.header-mega-menu-container {
              top: 60px;
            }
          }

          html, body {
          background-color: black;
          }

          #remedy-page ul {
            margin-left: 0;
          }
        `,
        }}
      />
      <HeroBlockSection pdpUrl={ctaUrl} ctaTitle={ctaTitle} />
      <TextInfoBlock1
        title="Experience Wellness at 39aF"
        ctaLinkText={ctaTitle}
        ctaText="Ice Bath by Remedy Place"
        ctaLinkHref={ctaUrl}
      />
      <BathLogoVideo />
      <TextInfoBlock2
        title="Design meets innovation"
        description="Kohler partnered with Dr. Jonathan Leary, founder and CEO of Remedy Place social wellness clubs, to create the world's premier ice bath. The Ice Bath By Remedy Place brings together a sophisticated, minimalist design with classleading functionality to help you create the ultimate home wellness space—indoors or outdoors."
      />
      <ScrollyBlock />
      <TimerVideoBlock />
      <ErgonomicsSection />
      <TechnicalSpecificationsSection />
      <FAQSection />
    </Box>
  )
}

export default Remedy
